import { render, staticRenderFns } from "./SubcategoriesPage.vue?vue&type=template&id=619e7504&scoped=true"
import script from "./SubcategoriesPage.vue?vue&type=script&lang=ts"
export * from "./SubcategoriesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619e7504",
  null
  
)

export default component.exports